// extracted by mini-css-extract-plugin
module.exports = {"IntroNavItems":"IntroNavItems_IntroNavItems__m8b7C","NavLink":"IntroNavItems_NavLink__qzTiT"};